import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

// Enregistrer les éléments nécessaires pour les graphiques en ligne
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

function ConsoChart({ data }) {
  // data = [{ date: "2025-11-16", today: "0.002", total: "0.338" }, ...]

  const labels = data.map(point => {
  const d = new Date(point.date);
  if (!isNaN(d.getTime())) {
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } else {
    return point.date;
  }
});

  const chartData = {
    labels,
    datasets: [
      {
        label: "Conso quotidienne (kWh)",
        data: data.map(point => Number(point.today)),
        fill: false,
        borderColor: "blue",
        tension: 0.2,
      },
      {
        label: "Conso totale (kWh)",
        data: data.map(point => Number(point.total)),
        fill: false,
        borderColor: "green",
        tension: 0.2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ height: 300 }}>
      <Line data={chartData} options={options} />
    </div>
  );
}

export default ConsoChart;
